import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { LoadingBarModule } from '@ngx-loading-bar/core';
import { TranslateService } from '@ngx-translate/core';
import { NotificationModalComponent } from '@shared/dialogs/notification-modal/notification-modal.component';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { HlmToaster } from '@spartan-ng/helm/sonner';
import { take } from 'rxjs';
import { InitialLoadingComponent } from 'src/app/features/initial-loading/components/initial-loading.component';
import { UserService } from './core/services/user.service';

@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    LoadingBarModule,

    HlmToaster,
    InitialLoadingComponent,
    NotificationModalComponent,
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component\.css',
})
export class AppComponent {
  oidc = inject(OidcSecurityService);
  userService = inject(UserService);

  private readonly translateService = inject(TranslateService);

  constructor() {
    this.oidc
      .checkAuth()
      .pipe(take(1))
      .subscribe({
        next: ({ accessToken }) => {
          this.userService.accessToken.set(accessToken || null);
          // Depois do token, sempre: quem observa o fim do carregamento inicial usa os dois
          // juntos, e ler o flag antes do token daria "sem sessão" por um instante.
          this.userService.authChecked.set(true);
        },
        // Falha do IdP: sem sessão confirmada. O carregamento inicial termina e o usuário cai no
        // fluxo de não autenticado, em vez de ficar preso na tela de carregamento.
        error: () => {
          this.userService.accessToken.set(null);
          this.userService.authChecked.set(true);
        },
      });
  }
}
